import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import CalendarioCargas from '../../containers/anunciosbuques/CalendarioCargas'
import { COLORES } from '../../../../config/colores'

function DialogoCalendarioCargas () {
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Proyección de carga de buques'
          content={<CalendarioCargas />}
        />
      </Dialog>

      <Button
        variant='contained'
        style={{ backgroundColor: COLORES.violet, color: 'white', fontWeight: 'bold' }}
        onClick={handleOpen}
      >
                Ver calendario cargas
      </Button>

    </>
  )
}

export default DialogoCalendarioCargas
